// LOTO Checklist Items - structure matches PDF exactly
// isHeader = true means it's a section header (red text), not answerable
// isQuestion = true means it has YES/NO/N/A answers
export const LOTO_CHECKLIST_ITEMS = [
    { id: 'taskSpecificJsa', text: 'Task specific JSA in place', isQuestion: true },
    { id: 'workersTrainedLtt', text: 'Workers trained in Lock-Tag-Try Process', isQuestion: true },
    { id: 'lotoProcedureHeader', text: 'LOTO Procedure', isHeader: true },
    { id: 'identifyEnergySources', text: 'Identify energy sources', isQuestion: true },
    { id: 'isolateEnergySources', text: 'Isolate energy sources', isQuestion: true },
    { id: 'applyLockoutDevices', text: 'Apply lockout devices & tags', isQuestion: true },
    // ensureSuitableSignage removed in V2
    { id: 'verifyZeroEnergy', text: 'Verify Zero Energy', isQuestion: true },
    { id: 'verifyMultimeter', text: 'Verify Multimeter - LIVE, DEAD, LIVE', isQuestion: true },
    { id: 'carryOutTaskHeader', text: 'Carry out task', isHeader: true },
    { id: 'removeLockoutDevices', text: 'Remove lockout devices & tags', isQuestion: true },
    { id: 'emergencyArrangementsHeader', text: 'EMERGENCY ARRANGEMENTS', isHeader: true },
    { id: 'rescuePlan', text: 'Rescue plan', isQuestion: true },
    { id: 'fireExtinguisher', text: 'Fire Extinguisher', isQuestion: true },
    { id: 'firstAiderOnSite', text: 'First aider on site', isQuestion: true }
];

// Only the questions (for validation - items that need answers)
export const LOTO_CHECKLIST_QUESTIONS = LOTO_CHECKLIST_ITEMS.filter(item => item.isQuestion);

// Energy Identification checklist
export const ENERGY_TYPES = [
    { id: 'mechanical', label: 'Mechanical' },
    { id: 'gravity', label: 'Gravity' },
    { id: 'lineOfFire', label: 'Line of Fire' },
    { id: 'electrical', label: 'Electrical' },
    { id: 'sound', label: 'Sound' },
    { id: 'temperature', label: 'Temperature' },
    { id: 'pressure', label: 'Pressure' },
    { id: 'steamWater', label: 'Steam/Water' },
    { id: 'biologicalChemical', label: 'Biological/Chemical' },
];

// Additional PPE Options (without Other - custom PPE handled separately)
export const PPE_OPTIONS = [
    { id: 'safetyGloves', label: 'Safety Gloves' },
    { id: 'fallProtection', label: 'Fall Protection' },
    { id: 'eyeProtection', label: 'Eye Protection' },
    { id: 'hearingProtection', label: 'Hearing Protection' },
    { id: 'respiratoryProtection', label: 'Respiratory Protection' },
    { id: 'arcFlashSuit', label: 'Arc Flash Suit' }
];

// Emergency Arrangements
export const EMERGENCY_ARRANGEMENTS = [
    { id: 'rescuePlan', label: 'Rescue plan' },
    { id: 'fireExtinguisher', label: 'Fire Extinguisher' },
    { id: 'firstAiderOnSite', label: 'First aider on site' }
];

// Signature Types (V2 uses checklistInitiator + completionVerification)
export const SIGNATURE_TYPES = {
    PERMIT_ISSUER: 'permitIssuer',
    PERMIT_ACCEPTOR: 'permitAcceptor',
    HAND_BACK: 'handBack',
    CANCELLATION: 'cancellation',
    // V2
    CHECKLIST_INITIATOR: 'checklistInitiator',
    COMPLETION_VERIFICATION: 'completionVerification'
};

// Hand Back Completion Status Options
export const HAND_BACK_STATUS = {
    COMPLETED: 'completed',
    PARTIALLY_COMPLETED: 'partiallyCompleted'
};

// Answer Options for LOTO Checklist
export const ANSWER_OPTIONS = {
    YES: 'yes',
    NO: 'no',
    NA: 'na'
};

// Form Status
export const LTT_STATUS = {
    NEW: 'new',
    DRAFT: 'draft',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    SUBMITTED: 'submitted'
};

// Mode types for Job/Location toggle
export const MODE_JOB = 'job';
export const MODE_LOCATION = 'location';
